import { clamp } from "lodash-es";
import {
	EXTRA_CONTRIBUTION_PROGRESS_MAX,
	EXTRA_CONTRIBUTION_PROGRESS_MIN,
} from "web_myplann/Goals/constants";
import type {
	ExtraContributionImpact,
	ExtraContributionInput,
} from "web_myplann/Goals/Types/ExtraContributionImpact";
import { MONTHS_IN_YEAR } from "web_myplann/Shared/constants";

export const calculateExtraContributionImpact = (
	goal: ExtraContributionInput,
	extraAmount: number,
): ExtraContributionImpact => {
	const currentYear = new Date().getFullYear();
	const yearsLeft = goal.dueYear - currentYear;
	const monthsLeft = Math.max(1, yearsLeft * MONTHS_IN_YEAR);

	const monthly = goal.monthlySavings;
	const speedsUp = extraAmount > 0 && monthly > 0;
	const remainingRatio = monthly > 0 ? monthly / (monthly + extraAmount) : 1;

	const monthsSaved = speedsUp
		? monthsLeft - Math.round(monthsLeft * remainingRatio)
		: 0;
	const newYear = speedsUp
		? Math.round(currentYear + (monthsLeft * remainingRatio) / MONTHS_IN_YEAR)
		: goal.dueYear;
	const progressPercent =
		yearsLeft > 0
			? clamp(
					((newYear - currentYear) / yearsLeft) * 100,
					EXTRA_CONTRIBUTION_PROGRESS_MIN,
					EXTRA_CONTRIBUTION_PROGRESS_MAX,
				)
			: EXTRA_CONTRIBUTION_PROGRESS_MAX;
	const extraTotal = extraAmount > 0 ? extraAmount * monthsLeft : 0;

	return {
		currentYear,
		dueYear: goal.dueYear,
		yearsLeft,
		monthsSaved,
		newYear,
		progressPercent,
		savingsTarget: goal.savingsTarget,
		extraTotal,
		newTargetTotal: goal.savingsTarget + extraTotal,
	};
};
